export const APPLICATION_DELETE_RESET = 'APPLICATION_DELETE_RESET'
export const APPLICATION_DELETE_SET_ERROR = 'APPLICATION_DELETE_SET_ERROR'
export const APPLICATION_DELETE_SET_DELETED = 'APPLICATION_DELETE_SET_DELETED'
export const APPLICATION_DELETE_TOGGLE_LOADING = 'APPLICATION_DELETE_TOGGLE_LOADING'
